import { useCallback, useMemo } from 'react';
import useInfiniteFetch from './useInfiniteFetch';
import { EXPANDED_ROWS_LIMIT } from '../constants/table';
import useSubscribeStorage from '../hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
import { WDAC_PACKAGED_APP_QUERY_KEY } from 'src/constants/query';
import useQueryParams from 'src/hooks/useQueryParams';
import { parseQueryToApiQuery } from 'src/utils/query.utils';
import WDACPackagedAppService from '../services/wdac-packaged-app.service';

const useFetchPackagedAppsByDeviceId = ({deviceId}) => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  const {
    queryObject: { filters = {}, searchValue: initialSearchValue },
  } = useQueryParams();

  const query = useMemo(
    () => parseQueryToApiQuery({ filters, searchValue: initialSearchValue }),
    [filters, initialSearchValue],
  );


  const fetchFunction = useCallback(
    ({ page, limit }) =>
      WDACPackagedAppService.getPackagedAppByDeviceIdAll({
        limit,
        page,
        customerEnvId,
        deviceId,
        query,
      }),
    [customerEnvId, deviceId, query],
  );

  const response = useInfiniteFetch({
    queryKey: [WDAC_PACKAGED_APP_QUERY_KEY, query, customerEnvId],
    fetchFunction,
    expandedRowsLimit: EXPANDED_ROWS_LIMIT,
    itemName: 'packagedApps',
  });

  return {
    ...response,
    query,
  };
};

export default useFetchPackagedAppsByDeviceId;
